export default __webpack_public_path__ + "static/media/left-men.f8c89811.png";